import { Accordion, AccordionSummary, ListItemText, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Styled } from "./styles";

const Nutritions = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5-content"
                id="panel5-header"
            >
                What is nutritional information?
            </AccordionSummary>
            <Styled.AccordionDetails>
                <Typography variant="body2">
                    Here is a list of what nutritional information should be provided per 100 ml
                    (energy in kJ/kCAL and other g):
                </Typography>
                <Styled.OrderedList>
                    <Styled.ListItem>
                        <ListItemText primary="Energy" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Fat of which: saturated fat" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Carbohydrates of which: sugars" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText primary="Protein" />
                    </Styled.ListItem>
                    <Styled.ListItem>
                        <ListItemText
                            primary="
                            Salt"
                        />
                    </Styled.ListItem>
                </Styled.OrderedList>
            </Styled.AccordionDetails>
        </Accordion>
    );
};

export default Nutritions;
